import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/algorand_logo_mark_black.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.hasClaimed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.localStateBetAlgos), 1),
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "on ", -1)),
        _createElementVNode("h1", {
          style: _normalizeStyle({color: _ctx.color})
        }, _toDisplayString(_ctx.localState.Team), 5)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Your Votes on ", -1)),
        _createElementVNode("h2", {
          style: _normalizeStyle({color: _ctx.color})
        }, _toDisplayString(_ctx.localState.Team), 5),
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, " has already been claimed", -1))
      ]))
}